import React, { useEffect, useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { BRAND, NAV_LINKS } from "../../mock";
import { openForm } from "./Pricing";

export const Logo = ({ className = "h-8 sm:h-9" }) => (
  <a href="/#top" className="group flex shrink-0 items-center gap-2 sm:gap-2.5" data-testid="logo" aria-label="EVTTuning UK home">
    <img src="/brand/evt-logo-dark.png?v=2" alt="EVTTuning" className={`${className} w-auto select-none object-contain`} draggable="false" />
    <span
      className="inline-flex -skew-x-[14deg] items-center bg-brand px-2 py-[3px] shadow-[0_6px_18px_-8px_rgba(239,28,37,.8)] transition-transform duration-300 group-hover:-translate-y-0.5 sm:px-2.5"
      data-testid="logo-uk"
    >
      <span className="skew-x-[14deg] font-display text-[14px] font-bold italic leading-none tracking-[0.12em] text-white sm:text-[16px]">UK</span>
    </span>
  </a>
);

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`fixed inset-x-0 top-0 z-50 border-b transition-colors duration-300 ${scrolled || open ? "border-white/10 bg-[#0b0c0f]/95 backdrop-blur-md" : "border-transparent bg-transparent"}`}>
      <div className="container-x flex h-[72px] items-center justify-between">
        <Logo />
        <nav className="hidden items-center gap-5 lg:flex">
          {NAV_LINKS.map((l) => (
            <a key={l.href} href={l.href} className="text-[15px] text-white/90 transition-colors hover:text-brand" data-testid={`nav-${l.href.slice(1)}`}>{l.label}</a>
          ))}
          <a href={BRAND.phoneHref} className="hidden items-center gap-2 text-[15px] text-white/90 transition-colors hover:text-brand xl:flex">
            <Phone className="h-4 w-4 text-brand" />{BRAND.phone}
          </a>
          <button onClick={() => openForm("enquiry")} className="rounded-lg border border-white/20 px-4 py-2.5 text-[15px] font-semibold text-white transition-colors hover:border-white/50 hover:bg-white/5" data-testid="nav-quote-btn">Get a Quote</button>
          <button onClick={() => openForm("booking")} className="btn-red rounded-lg px-5 py-2.5 text-[15px] font-semibold" data-testid="nav-book-btn">Book Now</button>
        </nav>
        <button className="text-white lg:hidden" onClick={() => setOpen(!open)} aria-label="menu" data-testid="mobile-menu-btn">
          {open ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
        </button>
      </div>
      <div className={`overflow-hidden transition-[max-height] duration-300 lg:hidden ${open ? "max-h-[420px]" : "max-h-0"}`}>
        <div className="container-x flex flex-col gap-1 pb-6">
          {NAV_LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="border-b border-white/5 py-3 text-white/90 hover:text-brand">{l.label}</a>
          ))}
          <a href={BRAND.phoneHref} className="flex items-center gap-2 py-3 text-white/90"><Phone className="h-4 w-4 text-brand" />{BRAND.phone}</a>
          <div className="mt-2 grid grid-cols-2 gap-3">
            <button onClick={() => { setOpen(false); openForm("enquiry"); }} className="rounded-lg border border-white/20 px-4 py-3 font-semibold text-white" data-testid="mobile-quote-btn">Get a Quote</button>
            <button onClick={() => { setOpen(false); openForm("booking"); }} className="btn-red rounded-lg px-4 py-3 font-semibold" data-testid="mobile-book-btn">Book Now</button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
